/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iletisim_S3_Form_LinkInputs */

const tr_iletisim_s3_form_link = /** @type {(inputs: Iletisim_S3_Form_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KVKK Başvuru Formu`)
};

const en_iletisim_s3_form_link = /** @type {(inputs: Iletisim_S3_Form_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KVKK application form`)
};

const de_iletisim_s3_form_link = /** @type {(inputs: Iletisim_S3_Form_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KVKK-Antragsformular`)
};

const ru_iletisim_s3_form_link = /** @type {(inputs: Iletisim_S3_Form_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Форму заявления KVKK`)
};

/**
* | output |
* | --- |
* | "KVKK application form" |
*
* @param {Iletisim_S3_Form_LinkInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iletisim_s3_form_link = /** @type {((inputs?: Iletisim_S3_Form_LinkInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iletisim_S3_Form_LinkInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iletisim_s3_form_link(inputs)
	if (locale === "de") return de_iletisim_s3_form_link(inputs)
	if (locale === "ru") return ru_iletisim_s3_form_link(inputs)
	return tr_iletisim_s3_form_link(inputs)
});